import React from "react";
import ConfigurationContainer from "containers/Configuration/index";


const Configuration = (props) => {
  return (
    <>
      <ConfigurationContainer {...props} />
    </>
  );
};

export default Configuration;